import { t } from 'i18next';
import { contractTypeEnum, specialUserTypeEnum } from '../enums';

export const contractTypeLabels: Record<number, string> = {
    [contractTypeEnum.APPRENTICE]: 'apprentice',
    [contractTypeEnum.FIXED_TERM]: 'fixedTerm',
    [contractTypeEnum.INTERN]: 'intern',
    [contractTypeEnum.OTHER]: 'other',
    [contractTypeEnum.PERMANENT]: 'permanent',
    [contractTypeEnum.TEMPWORKER]: 'tempWorker',
    [contractTypeEnum.SUBCONTRACTOR]: 'subContractor',
};

export const specialUserTypeLabels: Record<number, string> = {
    [specialUserTypeEnum.AMPLIROLL]: 'ampliroll',
    [specialUserTypeEnum.HEAVYTRANSPORTER]: 'heavyTransporter',
    [specialUserTypeEnum.SITE]: 'site',
    [specialUserTypeEnum.TRUCK]: 'truck',
    [specialUserTypeEnum.USER]: 'user',
};

export const getContractTypeLabel = (type?: number): string => {
    return type !== undefined && contractTypeLabels[type] ? t(contractTypeLabels[type]) : '';
};

export const getSpecialUserTypeLabel = (type?: number): string => {
    return type !== undefined && specialUserTypeLabels[type] ? t(specialUserTypeLabels[type]) : '';
};
